import { useTranslation } from "react-i18next";
import { TbInfoCircle } from "react-icons/tb";

function AboutSchool() {
  const { i18n, t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center rounded-lg font-ar bg-white max-w-[717px] w-[calc(60vw)] gap-4 h-fit py-8 mobile:py-0 mobile:w-[calc(100vw-32px)] mobile:h-auto drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-2 mobile:p-3">
        <p className="flex flex-row items-start mobile:text-mint-500 mobile:text-lg mobile:font-medium">
          {t("aboutSchool.container.aboutSchool")}
        </p>
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("aboutSchool.container.briefAboutSchool")}
        </label>
        <textarea
          className={`border-zinc400 focus:border-mint-500 w-[425px] h-32 bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-32 px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder={`${t(
            "aboutSchool.container.briefAboutSchoolPlaceholder"
          )}`}
        ></textarea>
      </div>

      <div className="flex flex-col gap-2 mobile:p-3">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("aboutSchool.container.costStartFrom")}
        </label>
        <input
          className={`border-zinc400 focus:border-mint-500 w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder={"12,500"}
        ></input>
      </div>

      <div className="flex flex-row justify-start gap-2 mobile:p-3 w-[425px] mobile:max-w-[345px] mobile:w-[calc(100vw-48px)]">
        <input type="checkbox" className="cursor-pointer"></input>
        <p className="text-zinc600 text-xl">
          {t("aboutSchool.container.availabilityApplying")}
        </p>
        <div className="group/outerDiv">
          <TbInfoCircle className="mt-0.5 text-[19px] text-zinc400" />
          <div
            className={`${
              i18n.language === "ar"
                ? "rounded-tl-xl mr-3"
                : "rounded-tr-xl ml-3"
            } absolute text-zinc400 text-xs rounded-b-xl w-72 mobile:w-fit p-2.5 bg-white group/infoDiv invisible group-hover/outerDiv:visible drop-shadow-[0_0px_14.3px_rgba(0,0,0,0.1)]`}
          >
            {t("aboutSchool.container.availbilityInfo")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSchool;
